import { TemplateStatus } from '@/services/templates.service';
import clsx from 'clsx';

const styles: Record<TemplateStatus, string> = {
  DRAFT:    'border-border bg-surface-alt text-text-secondary',
  PENDING:  'border-warning/30 bg-warning-soft text-warning',
  APPROVED: 'border-success/25 bg-success-soft text-success',
  REJECTED: 'border-danger/25 bg-danger-soft text-danger',
  PAUSED:   'border-warning/30 bg-warning-soft text-warning',
  DISABLED: 'border-border bg-surface-alt text-text-muted',
};

const dotStyles: Record<TemplateStatus, string> = {
  DRAFT:    'bg-text-muted',
  PENDING:  'bg-warning animate-pulse-soft',
  APPROVED: 'bg-success',
  REJECTED: 'bg-danger',
  PAUSED:   'bg-warning',
  DISABLED: 'bg-text-muted',
};

export const StatusBadge: React.FC<{ status: TemplateStatus }> = ({ status }) => (
  <span className={clsx('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-2xs font-semibold uppercase tracking-wide', styles[status])}>
    <span className={clsx('h-1.5 w-1.5 rounded-full', dotStyles[status])} />
    {status}
  </span>
);
